import { AdvancedVideo } from "@cloudinary/react";
import { Cloudinary } from "@cloudinary/url-gen";
import { quality } from "@cloudinary/url-gen/actions/delivery";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { GatsbyImage, getImage, ImageDataLike } from "gatsby-plugin-image";
import * as React from "react";
import {LocalizationMap, Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import MapView from "../MapView/MapView";
import { useAudioPlayer } from "../SoundControl/AudioPlayerContext";
import { ExtendedSanityAssetOrAssetFile } from "./Tabs";
import { useState } from "react";
import es_ES from '@react-pdf-viewer/locales/lib/es_ES.json';


export const mainContent = (
  _asset: ExtendedSanityAssetOrAssetFile,
  index: number,
  position: number,
  isMapOriginal: boolean,
) => {
  const { playAudio, pauseAudio } = useAudioPlayer();
  const [hasReloaded, setHasReloaded] = useState(false);
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  if (_asset.__typename === "Component") {
    return (
      <div className={"tabs__content"} key={index}>
        {_asset.component}
      </div>
    );
  }

  if (_asset.__typename === "MapView") {
    return (
      <div className={"tabs__content"} key={index}>
        <MapView />
      </div>
    );
  }

  if (_asset.__typename === "SanityAsset") {
    const asset = _asset as Queries.SanityAsset;
    if (asset?.file?.image) {
      const photoData = getImage(asset.file.image as unknown as ImageDataLike);
      if (!photoData) return <></>;
      return (
        <div className={"tabs__content"} key={index}>
          <GatsbyImage
            image={photoData}
            alt={asset?.name || ""}
            imgClassName={`${isMapOriginal ? "map-original-img" : ""}`}
            className={`${isMapOriginal ? "map-original" : "--cover"}`}
          />
        </div>
      );
    }
    if (asset.file?.format === "mp4") {
      const cld = new Cloudinary({
        cloud: {
          cloudName: process.env.GATSBY_CLOUDINARY_CLOUD_NAME || "",
        },
      });
      if (!asset.file?.public_id) return <></>;
      const video = cld.video(asset.file?.public_id).delivery(quality(80)).resize(fill().width(957).height(538));
      return (
        <div className={"tabs__content"} key={index}>
          <div style={{ position: "relative" }}>
            <AdvancedVideo
              className={"tabs__video"}
              cldVid={video}
              controls={true}
              cldPoster="auto"
              // autoPlay={position == index}
              autoPlay={false}
              muted={false}
              loop={true}
              onPlay={() => {
                pauseAudio();
              }}
            />
            {asset?.footLine && <small className={"tabs__foot-line"}>{asset?.footLine}</small> }
          </div>
        </div>
      );
    }
  }

  if (_asset.__typename === "SanityAssetFile") {
    const asset = _asset as Queries.SanityAssetFile;
    return (
      <div className={"tabs__content"} key={index}>
        {/*<object id={"object"} className={"placeholder__pdf"} data={`${asset?.file?.asset?.url}`} type="application/pdf">*/}
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.js">
            <div
              className={"placeholder__pdf"}
            >
              <Viewer
                localization={es_ES as unknown as LocalizationMap}
                fileUrl={asset?.file?.asset?.url || "/LitografiasEDA.pdf"}
                // plugins={[
                //   defaultLayoutPluginInstance,
                // ]}
              />
            </div>
          </Worker>
        {/*</object>*/}
      </div>
    );
  }
  return <></>;
};
